<template>
  <div>
    <b-card no-body header="Default" class="mb-0 card_question">
      <div slot="header">
        <div v-if="option.id && option.id > 0" class="right-card-main">
          <b v-b-tooltip.hover :title="$lang.azmoonLang.id_option">
            {{ option.id }}
          </b>
        </div>
        <div :class="`float-left ${option.id && option.id > 0 ? `ml-4` : ``} `">
          <b-button
            :class="`btn btn-lightgray btn-arrow ml-2 btn-secondary ml-2 ${
              option.id && option.id > 0 ? `arrow-rig-16` : `arrow-rig-8`
            }`"
            :title="$lang.drag_and_drop"
          >
            <i class="fas fa-arrows-alt"></i>
          </b-button>
          <div class="ml-4 text-main-option d-flex" v-if="!option.url">
            <span v-b-tooltip.hover :title="$lang.azmoonLang.number_option">
              ({{ $vnode.key + 1 }})
            </span>
            <span
              class="mx-2"
              v-html="createPureDom(option.option_description)"
            ></span>
          </div>
          <div class="ml-4 text-main-option" v-if="option.url">
            ({{ $vnode.key + 1 }}) <b-img :src="option.url" class="img-prev" />
          </div>
        </div>
        <div class="float-right">
          <b-button @click="removeItem(option)" variant="danger">
            <span v-b-tooltip.hover :title="$lang.remove" key="fa fa-times">
              <i class="fa fa-times" aria-hidden="true"></i>
            </span>
          </b-button>
          <b-button @click="toggleCollapse" variant="success" class="ml-2">
            <i aria-hidden="true" class="fa fa-angle-down fa-lg"></i>
          </b-button>
        </div>
      </div>
      <b-collapse v-model="isCollapse" class="mt-2">
        <b-overlay
          no-center
          :show="option.id > 0 ? true : false"
          :opacity="0.3"
        >
          <template v-slot:overlay><span class="d-none">icon</span> </template>
          <b-col v-if="option.url">
            <div class="img_style">
              <b-img :src="option.url" class="w-100 h-100" />
            </div>
          </b-col>
        </b-overlay>
        <b-col v-if="!option.is_image">
          {{ $lang.caption }}
          <Editor
            v-model="optionDescription"
            :toolbarItems="editorToolbarItems"
            @input="sendAnswerQuestion(option)"
          />
        </b-col>
        <b-col xs="12">
          <b-form-group
            label="مقدار گزینه option value:"
            label-for="address"
            :label-cols="$config.form.labelCol"
          >
            <!--change score -->
            <b-form-input
              id="weighting_question"
              type="number"
              v-model="option.value"
              @input="sendAnswerQuestion(option)"
            ></b-form-input>
          </b-form-group>
        </b-col>
        <b-col cols="12">
          <tagComponent
            :label="$lang.azmoonLang.option_group"
            category_name="option_group"
            :parentValue="option_group"
            @getSelected="getGroupSelected"
            :parentPermissions="parentPermissions"
          />
        </b-col>
      </b-collapse>
    </b-card>
  </div>
</template>

<script>
import Editor from "@/components/ckeditor/editorWithoutImg";
import tagComponent from "@/components/tag/tagComponent";
import { createPureDom } from "@/shared/utils";
export default {
  props: {
    option: {
      type: Object,
      default: () => {},
    },
  },
  components: {
    Editor,
    tagComponent,
  },
  data() {
    return {
      captionModal: false,
      isCollapse: false,
      quetionCaptions: "",
      optionDescription: null,
      option_group: {},
      parentPermissions: ["admin", "edit"],
      editorToolbarItems: [
        "alignment",
        "subscript",
        "superscript",
        "|",
        "blockQuote",
        "bulletedList",
        "numberedList",
        "todoList",
        "|",
        "undo",
        "redo",
      ],
    };
  },
  methods: {
    createPureDom,
    getGroupSelected(item) {
      this.option.option_group_id = item && item.value;
      this.$emit("getItem", this.option);
    },
    toggleModal() {
      this.captionModal = !this.captionModal;
    },
    toggleCollapse() {
      this.isCollapse = !this.isCollapse;
    },
    addCaption() {
      this.isCollapse = true;
    },
    removeItem(option) {
      this.$emit("removeItem", option);
    },
    sendAnswerQuestion(item) {
      this.$emit("getItem", item);
    },
  },
  watch: {
    optionDescription(val) {
      this.option.option_description = val;
    },
  },
  created() {
    if (this.option && this.option.option_group) {
      const { id, caption } = this.option && this.option.option_group;
      this.optionDescription = createPureDom(this.option.option_description);
      this.option_group = {
        value: id || ``,
        text: caption || ``,
      };
    }
  },
};
</script>

<style scope>
.icon-remove {
  cursor: pointer;
}

.btn-arrow {
  position: absolute;

  height: 100%;
  top: 0;
  border-radius: 0;
}
.arrow-rig-16 {
  right: 16px;
}
.arrow-rig-8 {
  right: -8px;
}
.text-main-option > p {
  margin: 0 !important;
}

.card_question > .card-header {
  position: relative !important;
}

.img_style {
  margin: auto;
  display: block;

  width: 150px;
  height: 150px;
}

.img-prev {
  width: 35px;
  height: 35px;
}
.right-card-main {
  position: absolute;
  top: 20px;
  right: -19px;
  text-align: center;
  width: 61px;
  transform: rotate(90deg);
}
</style>
